import React from 'react';
import { Radar } from 'react-chartjs-2';

interface RadarChartData {
  label: string;
  value: number;
}

interface RadarChartProps {
  data1: RadarChartData[];
  label1: string;
  data2: RadarChartData[];
  label2: string;
}

const RadarChart: React.FC<RadarChartProps> = ({ data1, label1, data2, label2 }) => {
  const radarData = {
    labels: data1.map(score => score.label),
    datasets: [
      {
        label: label1,
        data: data1.map(score => score.value),
        backgroundColor: 'rgba(135, 206, 250, 0.4)',
        borderColor: 'rgba(135, 206, 250, 1)',
        borderWidth: 2,
        pointBackgroundColor: 'rgba(135, 206, 250, 1)',
      },
      {
        label: label2,
        data: data2.map(score => score.value),
        backgroundColor: 'rgba(50, 205, 50, 0.2)',
        borderColor: 'rgba(50, 205, 50, 1)',
        borderWidth: 2,
        pointBackgroundColor: 'rgba(50, 205, 50, 1)',
      },
    ],
  };

  const radarOptions = {
    scales: {
      r: {
        suggestedMin: 0,
        suggestedMax: 10,
        ticks: {
          stepSize: 2,
          showLabelBackdrop: false,
          color: '#666',
        },
        grid: {
          color: '#ccc',
        },
        angleLines: {
          color: '#ddd',
        },
        pointLabels: {
          color: '#333',
          font: {
            family: 'Poppins, sans-serif',
            size: 12,
          },
        },
      },
    },
    plugins: {
      legend: {
        position: 'bottom' as const,
        display: false,
        labels: {
          font: {
            family: 'Poppins, sans-serif',
            size: 14,
          },
        },
      },
    },
    responsive: true,
    maintainAspectRatio: false,
  };

  return <Radar data={radarData} options={radarOptions} />;
};

export default RadarChart;
